import Route from '@ember/routing/route';
import { service } from '@ember/service';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';

export default class AuthenticatedAdminPslfFormSuccessRoute extends Route {
  @service declare store: StoreService;

  model(params: { form_id: string }) {
    return this.store.findRecord('pslf-form', params.form_id, { reload: true });
  }
}
